import baseApi from "@/api/baseApi";

const api = {
  async getSchedule(scheduleId) {
    const response = await baseApi({
      method: "get",
      url: `/schedule/${scheduleId}`,
    });

    return response.data;
  },

  async getActivities(scheduleId) {
    const response = await baseApi({
      method: "get",
      url: `/schedule/${scheduleId}/activities`,
    });

    return response.data;
  },

  async updateActivitie(data) {
    const response = await baseApi({
      method: "post",
      url: `/schedule/activitie/update`,
      data: data,
    });

    return response.data;
  },
  async completeSchedule(scheduleId) {
    const response = await baseApi({
      method: "post",
      url: `/schedule/complete/${scheduleId}`,
    });

    return response.data;
  },
  async addAberrationToActivity(data) {
    const response = await baseApi({
      method: "post",
      url: `/schedule/activity/aberration`,
      data: data,
    });

    return response.data;
  },
  async setScheduleComplete(data) {
    const response = await baseApi({
      method: "post",
      url: `/schedule/setcomplete`,
      data: data,
    });

    return response.data;
  },
};

export default api;
